module.exports = __webpack_public_path__ + "static/media/german-number-1-20.e9667b4a.PNG";